module.exports = __webpack_public_path__ + "static/map-numbers-471f1b04b883f9798ae91f8455a42cc7.png";